import { useLocation } from "react-router-dom";
import { useStateContext } from "context/ContextProvider";

const Footer = () => {
    const location = useLocation();
    const { analyticsLastUpdateDate } = useStateContext();

    const isInHomepage = location?.pathname?.includes("homepage");

    return (
        <div className="flex w-full flex-col items-center justify-between pb-8 pt-3 xl:flex-row">
            <div className="mb-4 flex gap-4 text-sm font-medium text-gray-600 sm:!mb-0 md:text-base">
                <h5>
                    ©{1900 + new Date().getYear()} Proxima. Tutti i diritti
                    riservati
                </h5>

                {isInHomepage && (
                    <div className="flex gap-4">
                        <span>|</span>
                        <span>
                            Dati aggiornati al:{" "}
                            {analyticsLastUpdateDate
                                ?.toLocaleString()
                                .slice(0, -3)}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Footer;
